import { useNavigate } from 'react-router-dom';
import { logout } from '../api/auth';

const Unauthorized = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem('role');

  const goToDashboard = () => {
    if (role === 'Admin') navigate('/admin/dashboard');
    else if (role === 'HR') navigate('/hr/dashboard');
    else if (role === 'member') navigate('/member/dashboard');
    else navigate('/login');
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--em-bg-head)',
      fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: 420,
        padding: '48px 32px',
        background: 'var(--em-bg-card)',
        borderRadius: 16,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        {/* Icon */}
        <div style={{
          width: 72, height: 72, borderRadius: '50%',
          background: '#fff7f5', border: '2px solid #ffe0d6',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px',
          fontSize: 32,
        }}>
          🔒
        </div>

        <h2 style={{
          fontSize: 22, fontWeight: 700, color: '#111827',
          margin: '0 0 10px',
        }}>
          Access Denied
        </h2>
        <p style={{
          fontSize: 14, color: 'var(--em-fg5)', lineHeight: 1.6,
          margin: '0 0 32px',
        }}>
          You don't have permission to view this page.
          If you think this is a mistake, contact your administrator.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {role && (
            <button
              onClick={goToDashboard}
              style={{
                padding: '11px 0', background: '#f54b01', color: '#fff',
                border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600,
                cursor: 'pointer', width: '100%',
              }}
            >
              Go to Dashboard
            </button>
          )}
          <button
            onClick={handleLogout}
            style={{
              padding: '11px 0', background: 'var(--em-bg-muted)', color: '#374151',
              border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600,
              cursor: 'pointer', width: '100%',
            }}
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
